import React from "react";
import ReactDOM from "react-dom"; // Import ReactDOM for createPortal
import Lottie from "react-lottie"; // Import Lottie component
import loadingAnimation from "../../assets/Lotties/ZinancialLoader.json"; // Your Lottie JSON file
import LoadingImg from "../../assets/Lotties/Z_Logo.gif";

const Loader = ({ isOpen }) => {
  const defaultOptions = {
    loop: true, // The animation will loop indefinitely
    autoplay: true, // The animation will autoplay
    animationData: loadingAnimation, // Lottie JSON animation
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return isOpen
    ? ReactDOM.createPortal(
        <div
          className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 flex justify-center items-center z-[999999999]"
          aria-live="polite"
          role="alert"
        >
          <div className="rounded-md">
            {/* <Lottie options={defaultOptions} height={150} width={150} isClickToPauseDisabled /> */}
            <span className="w-[100px] h-[100px]">
              <img src={LoadingImg} className="w-40 h-40 rounded-md" />
            </span>
          </div>
        </div>,
        document.getElementById("root") // Renders the loader into the root element or another designated div
      )
    : null;
};

export default Loader;
